import Vue from 'vue';
import VueRouter, { RouteConfig } from 'vue-router';
import requirement from './modules/requirementRouter';
import solution from './modules/solutionRouter';
import payment from './modules/paymentRouter';
import config from './modules/configRouter';
import module from './modules/moduleRouter';
import todo from './modules/todoRouter';
import issue from './modules/issueRouter';
// import account from './modules/accountRouter';
import report from './modules/reportRouter';
import Layout from '@/layout/index.vue';

Vue.use(VueRouter);

/*
name:'router-name'
  the name field is required when using <keep-alive>, it should also match its component's name property
  detail see : https://vuejs.org/v2/guide/components-dynamic-async.html#keep-alive-with-Dynamic-Components
redirect:''
  if set to 'noredirect', no redirect action will be trigger when clicking the breadcrumb
meta: {
  permissions: ['Team_Manage', 'Project_Manage']  will control the page permissions (allow setting multiple permissions)
  title: 'title'               the name showed in subMenu and breadcrumb (recommend set)
  icon: 'svg-name'             the icon showed in the sidebar
  hidden: true                 if true, this route will not show in the sidebar (default is false)
  alwaysShow: true             if true, will always show the root menu (default is false)
                              if false, hide the root menu when has less or equal than one children route
  breadcrumb: [{title: '', path: ''}]
                              if no setting, the item will be hidden in breadcrumb
  noCache: true                if true, the page will not be cached (default is false)
  affix: true                  if true, the tag will affix in the tags-view
  activeMenu: ['/example/list']  if set path, the sidebar will highlight the path you set
}
*/

// 固定路由(不需要权限控制)
export const constantRoutes: RouteConfig[] = [
  {
    path: '/redirect',
    component: Layout,
    meta: {
      hidden: true,
    },
    children: [
      {
        path: '/redirect/:path(.*)',
        component: () => import('@/views/redirect/index.vue'),
      },
    ],
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/login/login.vue'),
    meta: {
      hidden: true,
    },
  },
  {
    path: '/',
    name: 'Layout',
    component: Layout,
    meta: {
      hidden: true,
      affix: true,
      title: 'route.home',
      breadcrumb: [{title: 'route.home', path: '/'}],
    },
  },
  issue,
  requirement,
  solution,
  payment,
  module,
  todo,
];

// 异步路由(未来根据账号角色权限条件进行过滤, 得出符合权限的路由)
export const asyncRoutes: RouteConfig[] = [
  report,
  config,
  // account,
];
export const notFoundRoute: RouteConfig = {
  path: '*',
  redirect: '/404',
  component: Layout,
  children: [
    {
      path: '*',
      name: '404',
      component: () => import('@/views/404/index.vue'),
      meta: {
        hidden: true,
        affix: false,
        title: 'route.notFound',
        breadcrumb: [{title: 'route.notFound', path: '/'}],
      },
    },
  ],
};

const createRouter = () => new VueRouter({
  routes: constantRoutes,
});

const router = createRouter();

const originalPush: any = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location: any) {
  return originalPush.call(this, location).catch((err: any) => err);
};
// router.onError((err) => {});
export function resetRouter() {
  const newRouter = createRouter();
  (router as any).matcher = (newRouter as any).matcher; // reset router
}
export default router;
